import React, { createContext, useState, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

// Create the context
const NavigationContext = createContext();

// Custom hook to use the navigation context
export const useNavigation = () => useContext(NavigationContext);

// Provider component
export const NavigationProvider = ({ children }) => {
  const location = useLocation();
  const [isDashboard, setIsDashboard] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  
  // Detect if we're on the dashboard page
  useEffect(() => {
    setIsDashboard(location.pathname === "/" || location.pathname === "/dashboard");
  }, [location]);
  
  // Detect if we're on mobile and apply appropriate theme class
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 992; // Bootstrap lg breakpoint
      setIsMobile(mobile);
      
      // Apply theme classes based on screen size
      if (mobile) {
        document.body.classList.add('mobile-view');
        document.body.classList.remove('desktop-theme');
      } else {
        document.body.classList.add('desktop-theme');
        document.body.classList.remove('mobile-view');
      }
    };
    
    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      // Clean up classes when component unmounts
      document.body.classList.remove('mobile-view', 'desktop-theme');
    };
  }, []);
  
  // Value object to be provided to consumers
  const contextValue = {
    isDashboard,
    isMobile
  };
  
  return (
    <NavigationContext.Provider value={contextValue}>
      {children}
    </NavigationContext.Provider>
  );
};

export default NavigationContext;